/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export enum FONT_SIZES {
  SMALL = 'small',
  LARGE = 'large'
}

export enum CUSTOMTRANSFERLIST {
  MODULES = 'modules',
  LEFTBOX = 'leftBox',
  RIGHTBOX = 'rightBox'
}

export const AVAILABLE_MODULE_TEXT = 'Available Modules';
export const SELECTED_MODULE_TEXT = 'Selected Modules';
export const DISPLAY_EMPTY_SUBHEADING_LEFT_SIDE = 'Select some applications';
export const DISPLAY_EMPTY_SUBHEADING_RIGHT_SIDE = 'Add some modules from left';
export const ADD_ENTITLEMENT_FROM_ACCOUNT = 'Add entitlement from account';
export const SUBSCRIBED_MODULES = 'Subscribed Modules';